import {
  TableCell as MUITableCell,
  TableContainer as MUITableContainer,
  TableRow as MUITableRow,
  styled,
} from "@mui/material";

export const TableContainer = styled(MUITableContainer)``;

export const TableHeaderRow = styled(MUITableRow)`
  background: ${({ theme: { palette } }) => palette.grey[200]};
`;

export const TableCell = styled(MUITableCell)`
  color: ${({ theme: { palette } }) => palette.grey[600]};
  font-size: ${({
    theme: {
      typography: { size },
    },
  }) => size.sm};
`;

export const HeaderTableCell = styled(MUITableCell)`
  text-transform: uppercase;
  color: ${({ theme: { palette } }) => palette.grey[800]};
  font-weight: bold;
  font-size: ${({
    theme: {
      typography: { size },
    },
  }) => size.xs};
  white-space: nowrap;
`;

type TableRowProps = {
  index: number;
};

export const TableRow = styled(MUITableRow)<TableRowProps>`
  border-bottom: ${({
    theme: {
      palette: { light },
      borders: { borderWidth },
    },
  }) => `${borderWidth[2]} solid ${light.main}`};
  background: ${({ theme: { palette }, index }) =>
    index % 2 === 0 ? palette.white.main : palette.grey[100]};
`;
